import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ProductsGridComponent
} from './components';
import { MmFlexLayoutModule } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { ProductCardModule } from '~shared/modules/product-card/product-card.module';
import { IsVisibleModule } from '~shared/directives/is-visible/is-visible.module';

@NgModule({
  declarations: [
    ProductsGridComponent
  ],
  imports: [
    CommonModule,
    MmFlexLayoutModule,
    QaLocatorsModule,
    TranslateModule,
    ProductCardModule,
    IsVisibleModule
  ],
  exports: [
    ProductsGridComponent
  ]
})
export class ProductsGridModule { }
